import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  Box,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SmsIcon from "@mui/icons-material/Sms";

export type BalanceSmsType = "balance-with-link" | "text-only";

interface BalanceSmsDialogProps {
  open: boolean;
  onClose: () => void;
  onSend: (data: { text: string; type: BalanceSmsType }) => Promise<void>;
  selectedCount: number;
  isLoading: boolean;
}

const BalanceSmsDialog: React.FC<BalanceSmsDialogProps> = ({
  open,
  onClose,
  onSend,
  selectedCount,
  isLoading,
}) => {
  const [smsText, setSmsText] = useState<string>("");
  const [smsType, setSmsType] = useState<BalanceSmsType>("text-only");

  const handleSend = async () => {
    if (selectedCount === 0) {
      return;
    }
    await onSend({
      text: smsText,
      type: smsType,
    });
    // Reset form after successful send
    setSmsText("");
    setSmsType("text-only");
  };

  const handleClose = () => {
    setSmsText("");
    setSmsType("text-only");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>ارسال پیامک</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          تعداد مشتری انتخاب شده: {selectedCount}
        </Typography>

        <FormControl component="fieldset" sx={{ mb: 3, width: "100%" }}>
          <FormLabel component="legend">نوع پیامک</FormLabel>
          <RadioGroup
            value={smsType}
            onChange={(e) => setSmsType(e.target.value as BalanceSmsType)}
            row
          >
            <FormControlLabel
              value="balance-with-link"
              control={<Radio />}
              label="مانده حساب"
            />
            <FormControlLabel
              value="text-only"
              control={<Radio />}
              label="پیام متنی"
            />
          </RadioGroup>
        </FormControl>

        <TextField
          label="متن پیام"
          fullWidth
          multiline
          rows={3}
          value={smsText}
          onChange={(e) => setSmsText(e.target.value)}
          helperText={
            smsType === "balance-with-link"
              ? "می‌توانید از کدهای {balance}، {paymentLink} و {customerName} در هر جای متن استفاده کنید. فقط برای مشتریانی که مانده حسابشان بیشتر از 0 است ارسال می‌شود."
              : "می‌توانید از کد {customerName} در هر جای متن استفاده کنید."
          }
          placeholder={
            smsType === "balance-with-link"
              ? "مثال: سلام {customerName}، مانده حساب شما {balance} است. برای پرداخت: {paymentLink}"
              : "مثال: سلام {customerName}، این یک پیام متنی است."
          }
          sx={{ mb: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>بستن</Button>
        <LoadingButton
          variant="contained"
          onClick={handleSend}
          loading={isLoading}
          disabled={selectedCount === 0}
          startIcon={<SmsIcon />}
        >
          ارسال
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default BalanceSmsDialog;
